import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6846545c&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=6846545c&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.1_942d38e42bf4b987e783635c88cde9fa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports